import { consentManagementTour } from './consent-management';
import type { FeatureTour, FeaturesSeenMap } from '../../../types';

export const FEATURE_TOURS: FeatureTour[] = [
  consentManagementTour,
];

/**
 * Returns unseen tours filtered by role and registration date, sorted by priority.
 * Tours released before the researcher registered are skipped (the feature isn't "new" to them).
 * Only tours with status 'seen' in the featuresSeen map are considered seen.
 */
export function getUnseenTours(
  featuresSeen: FeaturesSeenMap,
  userRole: string,
  registeredAt?: string
): FeatureTour[] {
  return FEATURE_TOURS
    .filter((tour) => {
      const record = featuresSeen[tour.id];
      if (!record) return true;
      // 'seen', 'skipped', and 'cancelled' are terminal — never show again
      return record.status === 'later';
    })
    .filter((tour) => tour.requiredRole === 'any' || tour.requiredRole === userRole)
    .filter((tour) => {
      if (registeredAt && tour.releasedAt) {
        return new Date(tour.releasedAt) >= new Date(registeredAt);
      }
      return true;
    })
    .sort((a, b) => a.priority - b.priority);
}
